module.exports = __webpack_public_path__ + "static/img/img_5.e0f9121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hs_seniors_gallery/img_5.jpg
// module id = MylK
// module chunks = 0